import { OpenModal } from "../models/open-modal-state.model";

export class SetOpenModal {
  static readonly type = '[OPEN MODAL] Open Modal event';

  constructor(public payload: OpenModal) {
  }
}
